import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const AnalyticsFilters = ({ filters, onFilterChange }) => {
  const positionOptions = [
    { value: 'all', label: 'All Positions' },
    { value: 'Goalkeeper', label: 'Goalkeeper' },
    { value: 'Defender', label: 'Defender' },
    { value: 'Midfielder', label: 'Midfielder' },
    { value: 'Forward', label: 'Forward' }
  ];

  const leagueOptions = [
    { value: 'all', label: 'All Leagues' },
    { value: 'Premier League', label: 'Premier League' },
    { value: 'La Liga', label: 'La Liga' },
    { value: 'Bundesliga', label: 'Bundesliga' },
    { value: 'Serie A', label: 'Serie A' },
    { value: 'Ligue 1', label: 'Ligue 1' }
  ];

  const ageGroupOptions = [
    { value: 'all', label: 'All Ages' },
    { value: 'young', label: 'Young (18-23)' },
    { value: 'prime', label: 'Prime (24-29)' },
    { value: 'experienced', label: 'Experienced (30+)' }
  ];

  const valueRangeOptions = [
    { value: 'all', label: 'All Values' },
    { value: 'low', label: 'Under €5M' },
    { value: 'medium', label: '€5M - €20M' },
    { value: 'high', label: 'Over €20M' }
  ];

  const timeframeOptions = [
    { value: '7', label: 'Last 7 Days' },
    { value: '30', label: 'Last 30 Days' },
    { value: '90', label: 'Last 90 Days' },
    { value: '180', label: 'Last 6 Months' },
    { value: '365', label: 'Last Year' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Filter" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-foreground">Analytics Filters</h3>
          <p className="text-sm text-muted-foreground">Refine your market analysis</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Position</label>
          <Select
            value={filters?.position}
            onChange={(e) => onFilterChange('position', e?.target?.value)}
            options={positionOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">League</label>
          <Select
            value={filters?.league}
            onChange={(e) => onFilterChange('league', e?.target?.value)}
            options={leagueOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Age Group</label>
          <Select
            value={filters?.ageGroup}
            onChange={(e) => onFilterChange('ageGroup', e?.target?.value)}
            options={ageGroupOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Value Range</label>
          <Select
            value={filters?.valueRange}
            onChange={(e) => onFilterChange('valueRange', e?.target?.value)}
            options={valueRangeOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Timeframe</label>
          <Select
            value={filters?.timeframe}
            onChange={(e) => onFilterChange('timeframe', e?.target?.value)}
            options={timeframeOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsFilters;